module.exports = "/_next/static/images/c773c656a4a5ce5b8ed700414d4f785d-circles.svg";